import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Barbers() {
  const [barbers, setBarbers] = useState([]);
  useEffect(() => {
    api.get("/barbers").then((r) => setBarbers(r.data)).catch(() => {});
  }, []);

  const isSolo = barbers.length === 1;

  return (
    <section id="barbers" className="bg-[#0C0C0C] py-24 md:py-32 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-12 bg-[#FF3333]" />
            <span className="text-xs tracking-[0.3em] uppercase font-bold text-[#FF3333]">02 — The Team</span>
          </div>
          <h2 className="font-display font-black uppercase text-5xl md:text-7xl tracking-tighter leading-none">
            Behind the <span className="italic text-[#FF3333]">Chair</span>
          </h2>
        </div>

        <div
          className={
            isSolo
              ? "grid grid-cols-1 md:grid-cols-12 gap-10 items-center"
              : "grid grid-cols-1 md:grid-cols-3 gap-6"
          }
        >
          {barbers.map((b, idx) => (
            <div
              key={b.id}
              data-testid={`barber-${b.id}`}
              className={isSolo ? "md:col-span-12 grid grid-cols-1 md:grid-cols-12 gap-10 items-center group" : "group"}
            >
              <div className={`relative overflow-hidden ${isSolo ? "md:col-span-5 aspect-square" : "aspect-[3/4] mb-5"}`}>
                <img
                  src={b.image}
                  alt={b.name}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
                <div className="absolute top-4 left-4 font-display text-5xl font-black text-white/80 mix-blend-difference">
                  0{idx + 1}
                </div>
              </div>
              <div className={isSolo ? "md:col-span-7" : ""}>
                <div className="text-xs tracking-[0.25em] uppercase text-[#FF3333] mb-2">{b.title}</div>
                <h3 className={`font-display font-bold uppercase tracking-tight mb-3 ${isSolo ? "text-4xl md:text-5xl" : "text-2xl"}`}>
                  {b.name}
                </h3>
                <p className={`text-white/60 font-light leading-relaxed ${isSolo ? "text-lg" : "text-sm"}`}>
                  {b.bio}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
